import { render, staticRenderFns } from "./fullsizeModal.vue?vue&type=template&id=396eb2e8&scoped=true&"
import script from "./fullsizeModal.vue?vue&type=script&lang=js&"
export * from "./fullsizeModal.vue?vue&type=script&lang=js&"
import style0 from "./fullsizeModal.vue?vue&type=style&index=0&id=396eb2e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396eb2e8",
  null
  
)

export default component.exports